define([
    'text!./templates/change-free-garage-term-select-button.html',
], (templateStr) => {
    return () => ({
        restrict: 'E',
        template: templateStr,
        scope: {
            term: '=',
            disabledIf: '=?',
            changed: '&',
        },
        controller: ['$scope', function ($scope) {
            $scope.$watch('term.chosenTerm', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    $scope.changed();
                }
            });
        }],
    });
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/ChangeFreeGarageTermSelectButton.js